import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import TranslatedFeature from '../../../translated-feature/TranslatedFeature';
import { currentOrderedProductLevels } from './usePaidUsersModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const groupArrayIntoTwos = array => array.reduce((acc, value, index, fullArray) => {
  if (index % 2 === 0) {
    acc.push(fullArray.slice(index, index + 2));
  }
  return acc;
}, []);
export const PaidUsersFeatureCells = ({
  level,
  requiresPaidSeat,
  features,
  productMap
}) => {
  const apiName = productMap[level];
  const lowerProductLevel = currentOrderedProductLevels.indexOf(level) > 0 ? currentOrderedProductLevels[currentOrderedProductLevels.indexOf(level) - 1] : null;
  const lowerApiName = lowerProductLevel && productMap[lowerProductLevel];
  // We want to filter the features keeping any that apply to this level,
  // but aren't in the level below.
  // And filter based on requiresPaidSeat input
  const filteredFeatures = features.filter(feature => {
    if (!apiName) {
      return false;
    }
    const levelHasFeature = !!(feature.shortLimits[apiName] || feature.shouldUseDefaultLimits[apiName] || feature.productApiNames.includes(apiName));
    const lowerLevelHasFeature = !!(lowerApiName && (feature.shortLimits[lowerApiName] || feature.shouldUseDefaultLimits[lowerApiName] || feature.productApiNames.includes(lowerApiName)));
    const requiresSeat = feature.freeUserAccessLevel === 'NO_ACCESS';
    const hideLower = !requiresPaidSeat && lowerLevelHasFeature;
    return levelHasFeature && !hideLower && requiresPaidSeat === requiresSeat;
  });
  const featureDoubles = groupArrayIntoTwos(filteredFeatures);
  return featureDoubles.map(featureCouple => {
    return /*#__PURE__*/_jsxs("tr", {
      children: [featureCouple.map(feature => {
        return /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(Tooltip, {
            title: /*#__PURE__*/_jsx(TranslatedFeature, {
              translated: feature,
              attribute: "description"
            }),
            children: /*#__PURE__*/_jsx(View, {
              as: "span",
              cursor: "help",
              children: /*#__PURE__*/_jsx(TranslatedFeature, {
                translated: feature,
                attribute: "name"
              })
            })
          })
        }, feature.featureId);
      }), featureCouple.length === 1 && /*#__PURE__*/_jsx("td", {})]
    }, featureCouple[0].featureId);
  });
};